'use strict';

var UserManagementRoleManagementDirective = function UserManagementRoleManagementDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/user-management-role-management.html'),
    controller: 'UserManagementRoleManagementController',
    link: function link($scope) {
      $scope.$on('grid:icon-click', $scope.editRole);
      $scope.$watch('roleManagementState', function () {});
    }
  };
};
UserManagementRoleManagementDirective.$inject = [];
module.exports = UserManagementRoleManagementDirective;